import { database } from './firebase.js'

export async function loadChannelsFromCache() {
  let channels = await database.ref(`channels_cache`).once('value').then(res => res.val());

  if (channels)
    return Object.values(channels);
  else
    return [{
      title: 'first'
    }]
}

export async function getChannelName(channelId) {
  let name = await database.ref(`channels_cache/${channelId}/title`).once('value').then(res => res.val());

  if (name)
    return name;
  else
    return 'Unknown channel'
}

export async function getChannel(channelId) {
  let channel = await database.ref(`channels_cache/${channelId}`).once('value').then(res => res.val());

  if (channel)
    return channel;
  else
    return 'Unknown channel'
}

export async function getSubscriptions() {
  const subscriptions = await database.ref(`subscriptions`).once('value').then(res => res.val());

  if (subscriptions) {
    return subscriptions;
  } else {
    return [];
  }
}


export async function subscribeChannel(persSubscriptions) {
  try {
    const update = await database.ref(`subscriptions`).update(persSubscriptions);

    return update
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}



// WEBPACK FOOTER //
// ./src/services/firebase/channels.js